import { render, staticRenderFns } from "./SelectContactAddress.vue?vue&type=template&id=71c842b6&"
import script from "./SelectContactAddress.vue?vue&type=script&lang=ts&"
export * from "./SelectContactAddress.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71c842b6')) {
      api.createRecord('71c842b6', component.options)
    } else {
      api.reload('71c842b6', component.options)
    }
    module.hot.accept("./SelectContactAddress.vue?vue&type=template&id=71c842b6&", function () {
      api.rerender('71c842b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ContactData/SelectContactAddress.vue"
export default component.exports